import {
  FAILURE_WEATHER,
  FAILURE_PAST_WEATHER,
  REQUEST_PAST_WEATHER,
  RECEIVE_PAST_WEATHER,
  CLEAR_HISTORICAL_DATA,
  TOGGLE_TEMPERATURE_HELP,
  UPDATE_PAST_WEATHER_VALUE,
  TOGGLE_PRECIPITATION_HELP,
  RECEIVE_HISTORICAL_WEATHER,
  REQUEST_HISTORICAL_WEATHER,
  CLEAR_PAST_WEATHER_FAILURE,
} from '../constants/actionTypes';

export function failureWeather(error) {
  return {
    type: FAILURE_WEATHER,
    error,
  };
}

export function failurePastWeather(errors) {
  return {
    type: FAILURE_PAST_WEATHER,
    errors,
  };
}

export function clearPastWeatherFailure() {
  return {
    type: CLEAR_PAST_WEATHER_FAILURE,
  };
}

export function getPastWeather() {
  return {
    type: REQUEST_PAST_WEATHER,
  };
}

export function receivePastWeather(pastWeatherData) {
  return {
    type: RECEIVE_PAST_WEATHER,
    pastWeatherData,
  };
}

export function getHistoricalWeather() {
  return {
    type: REQUEST_HISTORICAL_WEATHER,
  };
}

export function receiveHistoricalWeather(historicalWeatherData) {
  return {
    type: RECEIVE_HISTORICAL_WEATHER,
    historicalWeatherData,
  };
}

export function clearHistoricalData() {
  return {
    type: CLEAR_HISTORICAL_DATA,
  };
}

export function updatePastWeatherInput(input, value) {
  return {
    type: UPDATE_PAST_WEATHER_VALUE,
    input,
    value,
  };
}

export function togglePrecipitationHelp() {
  return {
    type: TOGGLE_PRECIPITATION_HELP,
  };
}

export function toggleTemperatureHelp() {
  return {
    type: TOGGLE_TEMPERATURE_HELP,
  };
}
